// extracted by mini-css-extract-plugin
module.exports = {"sub":"ArticleSection_sub_8KDcK","spinAround":"ArticleSection_spinAround_1rGtA"};